import { useEffect } from "react"

const WIDGET_ORIGIN = "https://platform.botscrew.net"

// Site language from the URL path prefix, for the chat_language GA4 param.
const getChatLanguage = () => {
  const path = window.location.pathname
  if (path === "/es" || path.startsWith("/es/")) return "Spanish"
  if (path === "/fr" || path.startsWith("/fr/")) return "French"
  return "English"
}

const ChatBot = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const script = document.createElement("script")
      script.src = "https://platform.botscrew.net/find-mm/script-chatbot.js"
      script.type = "text/javascript"
      script.setAttribute(
        "data-server-url",
        "https://platform.botscrew.net/api"
      )
      script.setAttribute("data-icon-position", "bottom right 5% 15px")
      script.setAttribute("id", "chatbot-initials-script")
      script.setAttribute("data-bot-id", "a3100449-8913-4944-8e95-d848f3ff144f")
      script.setAttribute("data-openwidget", "false")
      document.body.appendChild(script)
    }, 6000)

    const sendOpen = () => {
      const iframe = document.getElementById("botscrew-widget")
      if (!iframe || !iframe.contentWindow) return false
      iframe.contentWindow.postMessage({ type: "open-widget" }, WIDGET_ORIGIN)
      return true
    }

    let widgetOpen = false
    let pendingOpenInterval = null
    let pendingOpenFallback = null
    const cancelPendingOpen = () => {
      clearInterval(pendingOpenInterval)
      clearTimeout(pendingOpenFallback)
      pendingOpenInterval = null
      pendingOpenFallback = null
    }

    // Any element with the `open-chat-btn` class opens the botscrew widget.
    // The widget script is injected 6s after mount, so a click can land before
    // the iframe exists — and the iframe's contentWindow exists before its
    // message listener does, so a single post can be silently lost. Re-send
    // until the widget confirms it opened (the toggle-widget message below).
    const handleOpenChatClick = (e) => {
      const trigger = e.target.closest(".open-chat-btn")
      if (!trigger) return
      e.preventDefault()
      if (widgetOpen || pendingOpenInterval) return
      sendOpen()
      pendingOpenInterval = setInterval(sendOpen, 200)
      pendingOpenFallback = setTimeout(cancelPendingOpen, 30000)
    }
    document.addEventListener("click", handleOpenChatClick, true)

    // GA4 chat_open (docs/CHAT-ANALYTICS.md). The widget iframe posts
    // `toggle-widget` to the parent window whenever it opens or closes; a GTM
    // click trigger can't see clicks inside the cross-origin iframe, so the
    // dataLayer push has to happen here. The GTM container's existing
    // chat_open custom-event trigger + GA4 tag pick it up from there.
    const handleWidgetMessage = (e) => {
      if (e.origin !== WIDGET_ORIGIN) return
      if (!e.data || e.data.type !== "toggle-widget") return
      widgetOpen = e.data.isWidgetOpen === true
      if (!widgetOpen) return
      cancelPendingOpen()
      if (process.env.GATSBY_CHAT_ANALYTICS_ENABLED !== "true") return
      if (sessionStorage.getItem("chat_open_fired")) return
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "chat_open",
        chat_platform: "website_widget",
        chat_language: getChatLanguage(),
        chat_trigger: "bubble_click",
      })
      sessionStorage.setItem("chat_open_fired", "true")
    }
    window.addEventListener("message", handleWidgetMessage)

    return () => {
      clearTimeout(timer)
      cancelPendingOpen()
      document.removeEventListener("click", handleOpenChatClick, true)
      window.removeEventListener("message", handleWidgetMessage)
    }
  }, [])

  return null
}

export default ChatBot
